// eslint-disable-next-line
import React, { Component } from "react";
import { connect } from "react-redux";

import { push } from "react-router-redux";

const mapStateToProps = state => ({
  auth: state.user.auth
});

const mapDispatchToProps = dispatch => ({
  routeToHome: () => dispatch(push("/"))
});

class DefaultDashboard extends Component {
  componentDidMount() {
    const { auth, routeToHome } = this.props;
    return auth ? null : routeToHome();
  }
  render() {
    return null;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DefaultDashboard);



// WEBPACK FOOTER //
// ./src/pages/default_dashboard/DefaultDashboard.js